<template>
  <div class="work_box">
    <TableBox :is-with-header="false" :table-contents="generateWorkData"/>
    <button @click="onClickDetail(work)" class="blue-ellipse_button">
      詳細を見る
    </button>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";
  import TableBox from "@/components/molecules/box/TableBox";
  import STATUSES from "@/assets/js/constants/statuses";
  import collection from "@/assets/js/functions/firebase/firestore/collection";

  export default {
    name: "WorkBox",

    components: {TableBox},

    mixins: [collection],

    props: {
      work: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters({customClaim: 'auth/customClaim'}),

      type() {
        let result = '';
        if (this.customClaim.isOperator && this.customClaim.isClient) {
          result = result + 'クライアント & オペレーター';
        } else if (this.customClaim.isOperator) {
          result = result + 'オペレーター';
        } else if (this.customClaim.isClient) {
          result = result + 'クライアント';
        }
        return result;
      },

      generateWorkData() {
        return {
          title: {
            dt: 'タイトル',
            dd: this.work.title,
          },
          status: {
            dt: 'ステータス',
            dd: this.displayStatus(this.work.status),
          },
          estimationOfWorkTime: {
            dt: '見積時間',
            dd: `${this.work.estimationOfWorkTime}分`,
          },
          deadline: {
            dt: '期限',
            dd: !this.work.deadline ? '' : moment.unix(this.work.deadline.seconds).format('YYYY/MM/DD HH:mm'),
          },
        }
      }
    },

    beforeCreate() {
      Object.assign(this, {STATUSES});
    },

    methods: {
      async onClickDetail(work) {
        if (STATUSES.SEARCHING.name === work.status || STATUSES.WAITING.name === work.status || STATUSES.MISSING.name === work.status) {
          this.$router.push({name: 'WorkDetail', params: {workId: work.id}});
          return;
        }

        const workRef = this.getDocPath('works', work.id);
        const query = this.getDocRef('matchings').where(
          "isDeleted", "==", false
        ).where(
          'work', '==', workRef
        ).limit(1);

        await this.retrieveDocs(query).then(docs => {
          const matchingId = docs[0].id;
          if (STATUSES.MATCHING.name === work.status) {
            this.$router.push({name: 'MatchingDetail', params: {matchingId: matchingId}});
          } else {
            this.$router.push({name: 'Meeting', params: {matchingId: matchingId}});
          }
        });
      },

      displayStatus(status) {
        let result = '';
        for (let [key] of Object.entries(STATUSES)) {
          if (STATUSES[key].name === status) {
            result = STATUSES[key].displayName
          }
        }
        return result;
      },
    }
  }
</script>


<style lang="scss" scoped>
  .work_box {
    display: flex;
    flex-flow: column;
    align-items: flex-end;

    > .table_box {
      margin: 2rem 0;
    }
    > .blue-ellipse_button {
      margin-bottom: 4rem;
    }
  }

</style>